// extracted by mini-css-extract-plugin
export default {"rowContainer":"FilesWidgetRow_rowContainer__UV+n6","filename":"FilesWidgetRow_filename__PxTLQ","actions":"FilesWidgetRow_actions__KTTkB"};